import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {TaskService} from "../../services/task.service";
import {switchMap} from "rxjs/operators";
import {forkJoin} from "rxjs";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  standalone: false,
  selector: 'alg-form-task-dialog',
  templateUrl: './form-task-dialog.html',
  styleUrls: ['../../ui/workflow-dialog.scss'],
})
export class FormTaskDialogComponent {

  ignoredPropertiesInForm = [
    "bpm:hiddenTransitions",
    "bpm:outcomePropertyName",
    "bpm:packageItemActionGroup",
    "bpm:completedItems",
    "bpm:completionDate",
    "bpm:packageActionGroup",
    "bpm:reassignable",
    "bpm:outcome",
    "bpm:description",
    "bpm:dueDate",
    "bpm:percentComplete",
    "bpm:priority",
    "bpm:taskId",
    "bpm:startDate",
    "bpm:context",
    "cm:name",
    "cm:content",
  ];

  formProperties = [];
  form: FormGroup = null;

  taskSelected: any;

  taskInstance: any;

  items: any;
  formLoading: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { obj: any },
              private taskService: TaskService,
              private fb: FormBuilder,
              public dialog: MatDialog) {
    this.taskSelected = data?.obj?.id;
    this.taskInstance = data?.obj;
  }

  ngOnInit() {
    this.taskService.getTaskInstance(this.taskSelected).pipe(
      switchMap((instance: any) => {
        let className = instance.data.definition.type.name;
        return forkJoin([
          this.taskService.getProperties(className),
          this.taskService.getVariables(this.taskSelected),
          this.taskService.getItems(this.taskSelected)
        ]);
      })
    ).subscribe(([response, variables, items]: [any, any, any]) => {
      this.items = items;

      let locals = variables.list.entries.filter(element => element.entry.name.startsWith("rc") || element.entry.name === "bpm_comment" || element.entry.scope === "local");

      this.formProperties = response.entry.properties.filter(element =>
        !this.ignoredPropertiesInForm.includes(element.id) && !element.isProtected
      );

      let associations = response.entry.associations.filter(element => element.id.startsWith("rc"));

      this.formProperties = [...this.formProperties, ...associations];

      this.formProperties.forEach(prop => {
        let value = locals.find(variable =>
          variable.entry.name === prop.id.replace(':', '_') || variable.entry.name === prop.id
        );
        if (value) {
          prop.value = value.entry.value;
        }
      });

      this.form = this.createForm();
      this.formLoading = false;
    });
  }

  createForm() {
    const formGroup = this.fb.group({});
    this.formProperties.forEach((prop) => {
      if (prop.title) {
        const validator = this.getValidator(prop);
        formGroup.addControl(prop.id, this.fb.control(prop.value ?? (this.isMultiValued(prop) ? [] : null), validator));
      }

    });
    return formGroup;
  }

  getValidator(prop) {
    const validators = [];
    if (prop.mandatory) {
      validators.push(Validators.required);
    }

    if (prop.constraints) {
      prop.constraints.forEach((constraint) => {
        if (constraint.type === 'LENGTH') {
          validators.push(Validators.minLength(constraint.parameters?.minLength));
          validators.push(Validators.maxLength(constraint.parameters?.maxLength));
        }
      });
    }

    return validators;
  }

  private isMultiValued(prop: any): boolean {
    return prop?.isMultiValued === true || prop?.multiValued === true || prop?.target?.isMany === true;
  }
}
